import { useEffect } from 'react';
import { useAppDispatch, useAppState } from '@/store';
import {
  getChannelLLMTemplate,
  selectChannelLLMTemplate,
  selectChannelLLMTemplateError,
  selectChannelLLMTemplateIsLoading,
} from '../feature';

export const useGetChannelLLMTemplate = ({ channelId }: { channelId?: number }) => {
  const isLoading = useAppState(selectChannelLLMTemplateIsLoading);
  const template = useAppState(selectChannelLLMTemplate);
  const error = useAppState(selectChannelLLMTemplateError);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!channelId) return;
    dispatch(getChannelLLMTemplate({ channelId }));
  }, [channelId, dispatch]);

  return {
    isLoading,
    template,
    error,
  };
};
